import { c, classy, m } from '@onfido/castor';
import { useField } from '@onfido/castor-react';
import React, { useMemo } from 'react';
import { withRef } from '../../utils';
export const Textarea = withRef(function Textarea({ id: initialId, resize = 'vertical', rows = 3, invalid, className, style, ...restProps }, ref) {
    const { disabled, touched } = useField();
    const id = useMemo(() => `castor_textarea_${++idCount}`, [initialId]);
    return (React.createElement("textarea", { disabled: disabled, ...restProps, ref: ref, id: id, rows: rows, className: classy(c('textarea'), m({ invalid, touched }), className), style: { ...style, resize } }));
});
let idCount = 0;
//# sourceMappingURL=textarea.js.map